import { useState } from 'react'
import { Tooltip } from 'react-tooltip'
import { Trans } from 'react-i18next'

import { MapView } from './Map'
import IconMap from '../IconMap'
import IconSatellite from '../IconSatellite'

type Props = {
  mapView: MapView
  setMapView: (mapView: MapView) => void
}

export default function MapviewButton({ mapView, setMapView }: Props) {
  const [isMapviewButtonHovered, setIsMapviewButtonHovered] = useState(false)
  const [isMapviewButtonPressed, setIsMapviewButtonPressed] = useState(false)

  const buttonStyle: React.CSSProperties = {
    position: 'absolute',
    bottom: '32px',
    right: '32px',
    height: '56px',
    width: '56px',
    padding: '0',
    fontSize: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'white',
    borderRadius: '50%',
    border: 'none',
    cursor: 'pointer',
    boxShadow: isMapviewButtonPressed
      ? '0px 2px 4px rgba(0, 0, 0, 0.2)'
      : isMapviewButtonHovered
        ? '0px 6px 12px rgba(0, 0, 0, 0.3)'
        : '0px 4px 6px rgba(0, 0, 0, 0.1)',
    transition: 'box-shadow 0.2s ease-in-out'
  }

  const handleMouseEnter = () => {
    setIsMapviewButtonHovered(true)
  }
  const handleMouseLeave = () => {
    setIsMapviewButtonHovered(false)
  }
  const handleMouseDown = () => {
    setIsMapviewButtonPressed(true)
  }
  const handleMouseUp = () => {
    setIsMapviewButtonPressed(false)
  }

  const handleClick = () => {
    const newMapView =
      mapView === MapView.DEFAULT ? MapView.SATELLITE : MapView.DEFAULT
    setMapView(newMapView)
  }

  return (
    <>
      <Tooltip anchorSelect=".change-mapview-button" place="top-start" noArrow>
        {mapView === MapView.DEFAULT ? (
          <Trans i18nKey="mapview_button.switch_to_sattelite">
            Switch to Satellite View
          </Trans>
        ) : (
          <Trans i18nKey="mapview_button.switch_to_map">
            Switch to Map View
          </Trans>
        )}
      </Tooltip>
      <button
        className="change-mapview-button"
        onClick={handleClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        style={buttonStyle}
      >
        {mapView === MapView.DEFAULT ? <IconSatellite /> : <IconMap />}
      </button>
    </>
  )
}
